export const PORT_MAP = new WeakMap();
//# sourceMappingURL=/build/es2019/helpers/port-map.js.map